export enum Purpose {
    ListPage = 0,
    Download = 1,
    Filter = 2,
    Edit = 3,
    Search = 4,
    Card = 5,
    AdvancedMapImage = 6,
    AdvancedMapAdditionalFields = 7
}